(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name ClipsController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('ClipsController', ClipsController);

    ClipsController.$inject = ["ClipsService","$timeout","$location",'$window',];

    function ClipsController(ClipsService,$timeout,$location,$window)
    {

        var vm = this;

        vm.loading = false;
        vm.filtros = {};
        vm.clips = [];

        vm.startDate = new Date();
        vm.endDate = new Date();
        vm.startDate.setDate(vm.endDate.getDate() - 90);

        vm.filtros.mesini = ("0" + (vm.startDate.getMonth()+1)).slice(-2);
        vm.filtros.mesend = ("0" + (vm.endDate.getMonth()+1)).slice(-2);
        vm.filtros.anoini = vm.startDate.getFullYear().toString();
        vm.filtros.anoend = vm.endDate.getFullYear().toString();

        vm.getClips = function(init){
            vm.loading = true;
          
            vm.clips = [];
            ClipsService.getClips(vm.filtros,function(data){
                vm.clips = data.clips;
                vm.loading = false;
                setTimeout(function(){ 
                    console.log('a');
                    $('.table-orders .collapse').on('shown.bs.collapse', function () {
                      var $scrollEl = $(this).closest('.card');
                      var $scrollWTo = $scrollEl.offset().top;
                      $('body, html').animate({ scrollTop: $scrollWTo - 80 }, 500);
                    });
                }, 100);
            });
        }


        vm.changeMes = function(init){
            vm.getClips(init);
        }


        //vm.getClips();

       
    }


})();